import { Link, useNavigate } from "react-router-dom";
import { Users, Trophy, CreditCard, Vote, Gift, CalendarDays, Shield, UserCircle2, LogOut, ChevronRight, ShoppingBag, History } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/common";
import { InstallButton } from "../components/InstallButton";

export default function More() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const items = [
    ["/app/atletas/" + user.user_id, UserCircle2, "Meu perfil"],
    ["/app/atletas", Users, "Atletas"],
    ["/app/etapas", CalendarDays, "Etapas"],
    ["/app/ranking", Trophy, "Ranking"],
    ["/app/cobrancas", CreditCard, "Cobranças"],
    ["/app/votacao", Vote, "Votação"],
    ["/app/brindes", Gift, "Sorteio de brindes"],
    ["/app/loja", ShoppingBag, "Loja"],
    ["/app/temporadas", History, "Temporadas"],
    ...(isAdmin ? [["/app/admin", Shield, "Administração"]] : []),
  ];
  return (
    <div>
      <PageHeader title="Mais" />
      <div className="space-y-2">
        {items.map(([to, I, l]) => (
          <Link key={to} to={to} data-testid={`more-${l.toLowerCase().replace(/\s+/g, "-")}`} className="card-x card-hover flex items-center gap-3 p-4">
            <I className="h-5 w-5 text-[#E4F222]" /><span className="flex-1 font-semibold">{l}</span><ChevronRight className="h-4 w-4 text-[#64748B]" />
          </Link>
        ))}
        <InstallButton testid="more-install-app" className="card-x flex w-full items-center gap-3 p-4 font-semibold text-[#E4F222]" label="Instalar app no celular" />
        <button data-testid="more-logout" onClick={async () => { await logout(); navigate("/"); }} className="card-x flex w-full items-center gap-3 p-4 text-red-400">
          <LogOut className="h-5 w-5" /> Sair
        </button>
      </div>
    </div>
  );
}
